import Vue, { ComponentOptions } from 'vue'
const template = require('./request-invite.html') as string;
import appWebConfig from '../../../../app.web.config';
import { IAccountService } from "../../../services/client/interfaces/iAccountService";
import { AccountService } from "../../../services/client/classes/accountService";
import CommonService from '../services/common-service';
import vSelect from "vue-select"
var emailRE = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var cityRE = /^[\D]{1,50}$/;

enum Page {
  UserType,
  UserDetails,
  LearnMore,
  AlreadyRegistered // this pertains to users who have already requested an invite and try to do so again
}

enum UserType {
  Employee = 'pro',
  CorporateAdministrator = 'firm',
  NonProfitRepresentative = 'nonprofit'
}

export default {
  template: template,

  data: function () {
    return {
      Enums: {
        Page: Page,
        UserType: UserType
      },

      currentPage: Page.UserType,

      validationInitiated: false,

      userData: {
        type: null,
        firstName: "",
        lastName: "",
        email: "",
        company: "",
        title: "",
        city: null,
        cityState: null,
        phone: "",
        useCityName: false,
        cityName: '',
      },
      cityOptions: [],
      cityStatesOptions: [],
      cityFocus: false,
    };
  },
  components: {
    vSelect
  },
  computed: {
    validation: function () {
      let obj = {
        firstName: !!this['userData'].firstName.trim(),
        lastName: !!this['userData'].lastName.trim(),
        email: emailRE.test(this['userData'].email),
        company: !!this['userData'].company.trim(),
        title: !!this['userData'].title.trim(),
        city: this['userData'].useCityName || !!this['userData'].city,
        state: !this['userData'].useCityName || !!this['userData'].cityState,
        cityName: !this['userData'].useCityName || cityRE.test(this['userData'].cityName.trim().replace(/  +/g, ' ')),
      };
      return obj;
    },
    isValid: function () {
      var validation = this['validation'];

      console.log('isValid', validation);
      return Object.keys(validation).every(function (key) {
        return validation[key]
      });
    }
  },
  mounted() {
    CommonService.getStates().then((res: any) => {
      this['cityStatesOptions'] = res.data.states;
    });

    CommonService.getCities('a').then((res: any) => {
      this['cityOptions'] = res.data.cities || [];
    });
  },
  methods: {
    selectType: function (type) {
      this['userData'].type = type;
      this['currentPage'] = Page.UserDetails;
        },
    back: function () {
      this['currentPage'] -= 1;
    },
    getCityOptions(search) {
      if (!search) {
          return;
      }
      CommonService.getCities(search).then((res: any) => {
          this['cityOptions'] = res.data.cities || [];
      });
    },
    onCityChange(val) {
        if (!val) {
            return;
        }
        this['userData'].city = val;
    },
    loadCityStates() {
        if (!this['cityStatesOptions'].length) {
            return;
        }
        const self = this;

        CommonService.getStates().then((res: any) => {
            self['cityStatesOptions'] = res.data.states || [];
        });
    },
    filterOptions(options) {
        return options.map((el: any) => {
            const option = {
                key: el.key,
                nameAndState: (!!el.name ? `${el.name.trim()}`:'')+(!!el.state ? `, ${el.state.trim()}`:''),
                name: el.name,
                state: el.state
            };

            return option;
        })
    },

    async getCompanyName(){
        let { data } = await CommonService.getOrgByEmail(this['userData'].email);
        this['userData'].company = data ? data.org_name : this['userData'].company;
    },

    complete: function () {
      let accountService: IAccountService = new AccountService();
      this['validationInitiated'] = true;

      if (this['isValid']) {
        let userData = this['userData'];
        let loginData = {
          email: userData.email
        };

        accountService.login(loginData).then(function (data: any) {
          let accountService: IAccountService = new AccountService();
          let cityName = userData.useCityName ? userData.cityName : userData.city.name;
          let cityState = userData.useCityName ? userData.cityState : userData.city.state;

          if (data.code === 'a57') {
              let nextStepToken = data.data.token;
              window.location.href = appWebConfig.public.onboarding.host + '?token=' + nextStepToken;
              try {
                  localStorage.setItem('userData', JSON.stringify(this['userData']));
              } catch (e) {

              }
          } else {
            // a58: Request Invite
            let postData = {
              member_type: userData.type == UserType.Employee ? 'Employee' : (userData.type == UserType.CorporateAdministrator ? 'Corporate Representative' : 'Nonprofit Representative'),
              first_name: userData.firstName,
              last_name: userData.lastName,
              work_email: userData.email,
              company: userData.company,
              city: { name: cityName, state: cityState },
              job_title: userData.title
            };

            accountService.register(postData).then((data: any) => {
              if (data.message === 'Member registered') {
                // created success
                this['currentPage'] = Page.LearnMore; //TODO spinner
              } else if (data.message === 'Member already exists') {
                // This block is triggered if the user who tried to request
                // tries to do another request. Previously there would be no
                // response, confusing the requesting user.
                this['currentPage'] = Page.AlreadyRegistered;
              } else {
                // maybe we need display error message on UI?
                this['isValidCredentials'] = false;
              }
            });
          }
        }.bind(this));
      }
    },
    toggleCityName() {
      this['userData'].useCityName = !this['userData'].useCityName;
    }
  }
} as ComponentOptions<Vue>



// WEBPACK FOOTER //
// ./static-content/public/javascripts/components/request-invite.ts